define(['jquery', 'core/ajax', 'core/str', 'core/url'],
function ($, ajax, str, moodleurl) {
  var index = {
      dom: {
          main: null
      },
      langs: {
      },
      action: {
          getString: function(merchantkey, currentcurrency) {
              str.get_strings([
              ]).done(function(s) {
                  index.init(merchantkey, currentcurrency);
              }).fail(function() {});
          },
           initDomVariable: function(){
            index.dom.totalAmount = index.dom.main.find('#totalAmount');
            index.dom.productId = index.dom.main.find('#product_id');
            index.dom.firstName = index.dom.main.find('#firstname');
            index.dom.description = index.dom.main.find('#description');
            index.dom.tId = index.dom.main.find('#tid');
          },
          initPayment: function(response,totalAmount,product_id,tid,currentcurrency) {
                $.ajax({
                        url: moodleurl.relativeUrl('/local/buykart/payment/razorpay/payment-process.php'),
                        type: 'post',
                        dataType: 'json',
                        data: {
                            razorpay_payment_id: response.razorpay_payment_id , totalAmount : totalAmount ,
                            product_id : product_id,tid : tid, currentcurrency : currentcurrency
                        }, 
                        success: function (msg) {
                        window.location.href = moodleurl.relativeUrl('/my/courses.php');
                        }
                    });
          },
      },
      init: function(merchantkey, currentcurrency) {
            index.dom.main = $('#mp-payment');          
            index.action.initDomVariable();
            var merchantkey = merchantkey;
            var currentcurrency = currentcurrency;
             index.dom.main.on("click", ".buy_now", function(e) {
                var totalAmount = index.dom.totalAmount.val();
                var product_id =  index.dom.productId.val();
                var name = index.dom.firstName.val();
                var description = index.dom.description.val();
                var tid = index.dom.tId.val();
                var options = {
                "key": merchantkey,
                "amount": (totalAmount*100), // 2000 paise = INR 20
                "name": name,
                "description": description,
                "tid": tid,
                "image": "https://uat2.itrackglobal.com/assets/min/en/itrack_logo2.webp",
                "handler": function (response){
                    index.action.initPayment(response,totalAmount,product_id,tid,currentcurrency);   
                },
                "theme": {
                    "color": "#528FF0"
                }
            };
            var rzp1 = new Razorpay(options);
            rzp1.open();
            e.preventDefault();
            });
      }
  };
  return {
      init: index.action.getString,

  };
});